/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';
import dayjs from 'dayjs';
import React from 'react';

import { ListeContainer, useListe } from '@mairistem/liste';

import type { Individu } from '@/types';

import RecenseListe from './RecenseListe';

interface RecenseListeContainerProps {
  doubleNationalite?: boolean;
  typeRecensement?:
    | 'all'
    | 'recenses'
    | 'recenses-regularises'
    | 'non-recenses'
    | 'recenses-recenses-regularises';
  periode?: string;
  simplified?: boolean;
  onSelect?: (item: Partial<Individu>) => void;
  defaultSearch?: string;
  defaultDateNaissance?: Date | null;
}

const RecenseListeContainer = (props: RecenseListeContainerProps = {}) => {
  const {
    doubleNationalite,
    typeRecensement,
    periode,
    simplified,
    onSelect,
    defaultSearch,
    defaultDateNaissance,
  } = props;

  const [dateNaissance, setDateNaissance] = React.useState<Date | null>(
    defaultDateNaissance || null,
  );

  const searchRef = React.useRef<string | undefined>(defaultSearch);

  const handleDateChange = React.useCallback((value: Date | null) => {
    setDateNaissance(value);
  }, []);

  const formattedDateNaissance = React.useMemo(() => {
    if (!dateNaissance || !dayjs(dateNaissance).isValid()) {
      return undefined;
    }
    return dayjs(dateNaissance).format('DD-MM-YYYY');
  }, [dateNaissance]);

  const defaultFilters = React.useMemo(
    () => ({
      ...(doubleNationalite && { doubleNationalite }),
      ...(typeRecensement && { typeRecensement }),
      ...(periode && { periode }),
      ...(formattedDateNaissance && { dateNaissance: formattedDateNaissance }),
      ...(defaultSearch && { q: defaultSearch }),
    }),
    [
      doubleNationalite,
      typeRecensement,
      periode,
      formattedDateNaissance,
      defaultSearch,
    ],
  );

  const [service] = useListe(
    '/api/administres/recensement-citoyen/individus/recenses',
    defaultFilters,
  );

  return (
    <ListeContainer
      key={formattedDateNaissance}
      type="recenses"
      contains="liste"
      service={service}
      perPage={15}
    >
      <RecenseListe
        simplified={simplified}
        onSelect={onSelect}
        dateNaissance={dateNaissance}
        onDateChange={handleDateChange}
        defaultSearch={searchRef.current}
        onSearchChange={(value: string) => {
          searchRef.current = value;
        }}
        typeRecensement={typeRecensement}
        displayRecensement={
          typeRecensement === 'all' &&
          _.size(periode) === 4 &&
          _.isNil(formattedDateNaissance) &&
          _.isNil(doubleNationalite)
        }
      />
    </ListeContainer>
  );
};

export default RecenseListeContainer;
